import React, { FC } from 'react';
import classNames from 'classnames';
import classes from '../../styles/index.module.scss';
import { ErrorBoundary } from '../../../../../../ReactSharedScripts/components/ErrorBoundary';
import { FlexGrid, FlexGridColumn } from '../../../../../../ReactSharedScripts/components/FlexGrid';
import { Spinner } from '../../../../../../ReactSharedScripts/components/CloakLoading';
import { ModalHeaderProps } from '../../../../../../ReactSharedScripts/components/ModalBox/types';
import { Close } from '../../../../../../ReactSharedScripts/components/Icons/Close';
import { Collapse } from '../../../../../../ReactSharedScripts/components/Icons/Collapse';
import { FullScreen } from '../../../../../../ReactSharedScripts/components/Icons/FullScreen';

export const Header: FC<ModalHeaderProps> = ({
	className,
	title,
	onClose,
	hasFullScreen,
	hideCloseButton,
	fullScreen,
	toggleFullScreen,
	isLoading,
}) => {
	const componentClasses = classNames(classes.header, className);

	const fullScreenButtonClasses = classNames(classes.headerTool, classes.fullScreenButton);

	const closeButtonClasses = classNames(classes.headerTool, classes.closeButton);

	return (
		<ErrorBoundary>
			<div className={componentClasses}>
				<div
					className={classes.headerTitle}
					data-testid='modalBoxHeaderTitle'
				>
					{isLoading && (
						<FlexGrid
							gap='small'
							center
						>
							<FlexGridColumn>{title}</FlexGridColumn>
							<FlexGridColumn>
								<Spinner
									light
									dataTestId='modalBoxHeaderSpinner'
									style={{
										top: 0,
									}}
								/>
							</FlexGridColumn>
						</FlexGrid>
					)}
					{!isLoading && title}
				</div>
				<div className={classes.headerTools}>
					{hasFullScreen && (
						<button
							type='button'
							onClick={toggleFullScreen}
							className={fullScreenButtonClasses}
							data-testid='modalBoxToggleFullScreenButton'
							tabIndex={-1}
						>
							{fullScreen ? <Collapse /> : <FullScreen />}
						</button>
					)}
					{!hideCloseButton && (
						<button
							type='button'
							onClick={onClose}
							className={closeButtonClasses}
							data-testid='modalBoxCloseButton'
							tabIndex={-1}
						>
							<Close />
						</button>
					)}
				</div>
			</div>
		</ErrorBoundary>
	);
};
